import React from "react";
import Home1 from "./Home1";
import Home2 from "./Home2";
import Home3 from "./Home3";
import NavbarHome from "../navbar/NavbarHome";
import Footer from "../Footer/Footer";
const Home = () => {
  return (
    <div>
      <div className="mt-0">
        <Home1 />
        <Home2 />
        <Home3 />
      </div>
    </div>
  );
};

export default Home;
